// extracted by mini-css-extract-plugin
export default {"resultContainer":"ResultsContainer_resultContainer__jy7wj"};